import { useCallback, useEffect, useState } from 'react';
import { getEntrevistasByPaciente } from '../api/pacientesApi';
import { mapEntrevistasToRows } from '../utils/pacienteMappers';

export const usePacienteEntrevistas = ({ idPaciente }) => {
  const [entrevistas, setEntrevistas] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEntrevistas = useCallback(async () => {
    if (!idPaciente) return;
    setLoading(true);
    try {
      const data = await getEntrevistasByPaciente(idPaciente);
      setEntrevistas(mapEntrevistasToRows(data, idPaciente));
    } catch (error) {
      console.error('Error al obtener los datos:', error);
      setEntrevistas([]);
    } finally {
      setLoading(false);
    }
  }, [idPaciente]);

  useEffect(() => {
    fetchEntrevistas();
  }, [fetchEntrevistas]);

  return { entrevistas, loading, fetchEntrevistas };
};
